import { createReducer, on } from "@ngrx/store";

import { ProductContainerActions } from './product-containers.actions';

import { initialState, productContainersAdapter } from "./product-containers.state";
import { LoadingState } from "@core/models";


export const productContainersReducer = createReducer(
  initialState,

  on(ProductContainerActions.reset, (state) => ({ ...initialState })),

  on(ProductContainerActions.add, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductContainerActions.addSuccess, (state, { productContainer }) => {
    return productContainersAdapter.upsertOne(productContainer, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductContainerActions.addFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductContainerActions.deActivate, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductContainerActions.deActivateSuccess, (state, { productContainer }) => {
    return productContainersAdapter.upsertOne(productContainer, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductContainerActions.deActivateFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductContainerActions.update, (state, { deactivateCommand, addCommand }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductContainerActions.updateSuccess, (state, { productContainer }) => {
    return productContainersAdapter.upsertOne(productContainer, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductContainerActions.updateFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(ProductContainerActions.load, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(ProductContainerActions.loadSuccess, (state, { productContainers }) => {
    return productContainersAdapter.upsertMany(productContainers, { ...state, callState: LoadingState.LOADED });
  }),
  on(ProductContainerActions.loadFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),
);